import {
  combineSlices,
  configureStore,
  Action,
  ThunkAction,
} from "@reduxjs/toolkit"
import { setupListeners } from "@reduxjs/toolkit/query"
import { apiSlice } from "./slices/api.slice"
import { userSlice } from "./slices/user.slice"
import { companySlice } from "./slices/company.slice"
import { emptySplitApi } from "../api/emptyApi"
import { experimentApi } from "../api/experimentApi"
import { ingestionApi } from "../api/ingestionApi"
import { fileDropApi } from "../api/fileDropApi"
import { campaignBlasterApi } from "../api/campaignBlasterApi"
import { loadingSlice } from "./slices/loading.slice"
import { drawerSlice } from "./slices/drawer.slice"
import { demoSlice } from "./slices/demo.slice"
import { paidMediaSlice } from "./slices/paid-media.slice"
import { adForgeSlice } from "./slices/ad-forge.slice"
import { assetCacheSlice } from "./slices/asset-cache.slice"
import { chatbotSlice } from "./slices/chatbot.slice"
import { sentryReduxEnhancer } from "./sentry-redux-enhancer"

const rootReducer = combineSlices(
  userSlice,
  companySlice,
  emptySplitApi,
  apiSlice,
  experimentApi,
  ingestionApi,
  fileDropApi,
  campaignBlasterApi,
  loadingSlice,
  drawerSlice,
  demoSlice,
  paidMediaSlice,
  adForgeSlice,
  assetCacheSlice,
  chatbotSlice,
)

export type RootState = ReturnType<typeof rootReducer>

export const makeStore = (preloadedState?: Partial<RootState>) => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(
        emptySplitApi.middleware,
        apiSlice.middleware,
        experimentApi.middleware,
        ingestionApi.middleware,
        fileDropApi.middleware,
        campaignBlasterApi.middleware,
      ),
    preloadedState,
    enhancers: getDefaultEnhancers =>
      getDefaultEnhancers().concat(sentryReduxEnhancer),
  })
  setupListeners(store.dispatch)
  return store
}

export const store = makeStore()

export type AppStore = typeof store

export type AppDispatch = AppStore["dispatch"]
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>
